// extracted by mini-css-extract-plugin
export var articleMultipleChoiceCTA = "bV_fN";
export var mainHeader = "bV_f9";